module.exports = __webpack_public_path__ + "static/media/12.2e7c39df.jpg";